import Loanapplications from "../../../jsx/components/Dashboard/LoanApplications/loanapplications";

const LoanApplicatiionsWrapper = () => {
  return <Loanapplications />;
};

export default constore(LoanApplicatiionsWrapper);
